// extracted by mini-css-extract-plugin
export var acitonButtons = "_m5-0";
export var additionalIcon = "_m5-f";
export var block = "_m5-1";
export var blockContent = "_m5-7";
export var blockDescription = "_m5-8";
export var blockIcon = "_m5-9";
export var blockTitle = "_m5-6";
export var border = "_m5-a";
export var center = "_m5-l";
export var edge = "_m5-b";
export var edgeLabel = "_m5-c";
export var edgePath = "_m5-d";
export var error = "_m5-e";
export var flowchart = "_m5-g";
export var flowchartContent = "_m5-h";
export var highlighted = "_m5-3";
export var hover = "_m5-4";
export var icon = "_m5-i";
export var left = "_m5-m";
export var navButton = "_m5-j";
export var navButtons = "_m5-k";
export var right = "_m5-n";
export var selected = "_m5-2";
export var small = "_m5-5";